import { render } from "./PorchPiano.vue?vue&type=template&id=7a451f55"
import script from "./PorchPiano.vue?vue&type=script&lang=js"
export * from "./PorchPiano.vue?vue&type=script&lang=js"

import "./PorchPiano.vue?vue&type=style&index=0&id=7a451f55&lang=scss"
script.render = render

export default script